import { useState } from "react";
import { paths, API_URL } from "../config/endpoints";
import { useNavigate } from "react-router-dom";

const useAddReservation = () => {
  const apiUrl = `${API_URL}/${paths.guest}/${paths.reservations}/${paths.addMissing}`;
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [showSuccessScreen, setShowSuccessScreen] = useState<boolean>(false);
  const [referenceCode, setReferenceCode] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const navigate = useNavigate();

  const addReservation = async () => {
    setLoading(true);
    setErrorMessage(null);
    setShowSuccessScreen(false);

    try {
      // Retrieve the token from localStorage
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Authentication token is missing. Please log in.");
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include the token in the request headers
        },
        body: JSON.stringify({
          referenceCode,
          lastName,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add reservation. Please try again.");
      }

      // Handle the successful response
      setShowSuccessScreen(true);

      // Redirect to the home page
      navigate("/home");
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    errorMessage,
    showSuccessScreen,
    referenceCode,
    lastName,
    setReferenceCode,
    setLastName,
    addReservation,
  };
};

export default useAddReservation;
